export const sidebarMakePaymentElem = $('#sidenav_accordion .make_payment > a')

export const makePaymentModalElem = $('#make-payment-modal')

// Modal title
export const makePaymentModalTitleElem = makePaymentModalElem.find('.modal-header h3')

// Modal loading
export const makePaymentModalLoadingElem = makePaymentModalElem.find('.payment-loading')

// Modal errors
export const makePaymentModalErrorElem = makePaymentModalElem.find('.payment-error')
export const makePaymentModalErrorListElem = makePaymentModalErrorElem.find('ul')

// Modal unit select
export const makePaymentModalSelectElem = makePaymentModalElem.find('.payment-select')
export const makePaymentModalUnitSelectElem = makePaymentModalElem.find('.unit-select')
export const makePaymentModalUnitsSelectElem = makePaymentModalElem.find('#units')
export const makePaymentModalUnitsUsersSelectElem = makePaymentModalElem.find('#units_user_uuid')

// Modal balance
export const makePaymentModalBalanceElem = makePaymentModalElem.find('.payment-display')
export const makePaymentModalBalanceAmountElem = makePaymentModalBalanceElem.find('.payment-balanace-amount')
export const makePaymentModalBalanceCurrentElem = makePaymentModalBalanceElem.find('.payment-balanace-current')
export const makePaymentModalBalanceDateElem = makePaymentModalBalanceElem.find('.payment-balanace-date')
export const makePaymentModalBalanceAttorneyElem = makePaymentModalElem.find('.payment-attorney')

// Modal display
export const makePaymentModalDisplaySelectElem = makePaymentModalElem.find('.modal-body-select')
export const makePaymentModalDisplayPayElem = makePaymentModalElem.find('.modal-body-pay')

// Modal footer
export const makePaymentModalFooterElem = makePaymentModalElem.find('.modal-footer')
export const makePaymentModalFooterContinueElem = makePaymentModalFooterElem.find('.footer-continue a')
export const makePaymentModalFooterPayElem = makePaymentModalFooterElem.find('.footer-pay a')
export const makePaymentModalFooterBackElem = makePaymentModalFooterElem.find('.footer-back a:first')

export const makePaymentModalFooterContinueContainerElem = makePaymentModalFooterElem.find('.footer-continue')
export const makePaymentModalFooterPayContainerElem = makePaymentModalFooterElem.find('.footer-pay')
export const makePaymentModalFooterBackContainerElem = makePaymentModalFooterElem.find('.footer-back')

// Modal data attributes
export const makePaymentUrlData = makePaymentModalElem.find('.modal-body').attr('data-payment-url')
export const makePaymentProviderData = makePaymentModalElem.attr('data-provider')
